/**
 * 刚和周伟确认了一下，有几个问题，需要说一下，因为确实目前已经做好的项目做不了
  1，有文字性的数据才上传数据，比如这个按钮上面是图片或者图标的，这种就不上传
  2，一个页面上面有多个按钮的，没办法区分是属于哪个功能
  3，input框的点击不上传，像页面上面的单选，多选，其实都是input，这种也不上传数据
  4，点击空白处继续上传数据，但是有限制，目前和后端鹏哥沟通的tableId不能超过512个字符，
  5，所有的弹窗，都需要做，因为之前我限制了，所以没有上传，后面会全部放开
  6, 点击事件涉及路由跳转的，pageID都以跳转之后的路由名字为准------2023年1月18号改为就以点击事件当前的路由
  7， 如果多次触发同一个事件，继续推送数据
  8，如果因为调用某种浏览器自身弹窗中断了js执行，接受关掉弹窗再发送请求
 */
  import CryptoJS from 'crypto-js'
  import axios from 'axios';
  import { MessageBox } from 'element-ui';
  var entryTime = null;
  var leaveTime = null;
  var currentRoute = null;
  var lastRoute = null;
  var currentElement = null;
  var province = '';
  var longLat = '';
  var isReady = false;
  var userInfo = {};
  var clickTime = null;// 点击事件产生的时间
  let requestParam = null;
  let localIp = null;
  const browser = {
      versions: (function () {
        var u = navigator.userAgent
        return {
          trident: u.indexOf('Trident') > -1,
          presto: u.indexOf('Presto') > -1,
          webKit: u.indexOf('AppleWebKit') > -1,
          gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1,
          mobile: (!!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/)) && u.indexOf('QIHU') && u.indexOf('QIHU') > -1 && u.indexOf('Chrome') < 0,
          ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
          android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
          iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1,
          iPad: u.indexOf('iPad') > -1,
          webApp: u.indexOf('Safari') === -1,
          iosApp: u.indexOf('app/native_iOS') > -1,
          AndroidApp: u.indexOf('app/ANDROID') > -1
        }
      }()),
      language: (navigator.browserLanguage || navigator.language).toLowerCase()
  }
   // 获取用户本地ip的方法
const getUserIP = (onNewIP)=> {
  if(typeof window != 'undefined'){
      var RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
      if (RTCPeerConnection) {(()=>{
          var rtc = new RTCPeerConnection()
          rtc.createDataChannel(''); // 创建一个可以发送任意数据的数据通道
          rtc.createOffer( offerDesc => { // 创建并存储一个sdp数据
          rtc.setLocalDescription(offerDesc)
      }, e => { console.log(e)})
      rtc.onicecandidate = (evt) => { // 监听candidate事件
          if (evt.candidate) {
              console.log('evt:',evt.candidate)
              let ip_rule = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}((:[a-f0-9]{1,4}){7}|(:[a-f0-9]{1,4}){6}))/
              var ip_addrs = evt.candidate.candidate.match(ip_rule)
              localIp  = ip_addrs ? ip_addrs[1] : ''
              console.log('ip_addr:',localIp)   // 打印获取的IP地址
          }}
      })()}
      else{console.log("没有找到")}
    }
  }
  // const key = CryptoJS.enc.Utf8.parse("1234123412ABCDEF")  //十六位十六进制数作为密钥
  // let srcs1 = CryptoJS.enc.Utf8.parse(this.formLabelAlign.oldPass) // 先将对象变为字符串，然后将这个字符串变为AES对象初始化，key也要经过AES对象初始化
  // let encryStr1 = CryptoJS.AES.encrypt(srcs1, key, {mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7}).toString() // 需要改为字符串
  // let srcs2 = CryptoJS.enc.Utf8.parse(this.formLabelAlign.newPass) // 先将对象变为字符串，然后将这个字符串变为AES对象初始化，key也要经过AES对象初始化
  // let encryStr2 = CryptoJS.AES.encrypt(srcs2, key, {mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7}).toString() // 需要改为字符串
  export default {
      install(Vue){
        let vm = this;
          if(this.isIOS()){
            this.setupWebViewJavascriptBridge();
          }else {
            this.getUserInfo();
          }
          getUserIP()
          // 离开的时候进入下一次路由，这个时候from的路由就是上一次销毁的路由
          Vue.$router.beforeEach((to, from, next) => {
              lastRoute = from.name;
              leaveTime = new Date();
              currentRoute = to.name;
              if(from.fullPath != '/'){
                this.sendData('view',this);
              }
              next();
          });
          Vue.$router.afterEach((to, from) => {
            currentRoute = to.name;
            entryTime = new Date();
          });
          Vue.prototype.$exposurePonit = (data) => {
            // 曝光事件
            vm.sendData('exposure', vm, data);
          }
          Vue.prototype.$queryDataBurialPoint = (data) => {
			// 全局方法
                var model = data.model || {};
                var itemList = data.queryList;
                var arr = [];
                for(var key in model){
                    var data = model[key];
                    let currentItem = itemList.find(it => it.name === key);
                    if((data || data === 0) && currentItem){
                        let valuetext = data;
                        if(currentItem.optionsList || currentItem.radioList){
                            let arr = currentItem.optionsList || currentItem.radioList;
                            let obj = arr.find(it => (it.id || it.value) == data);
                            if(obj){
                                valuetext = obj.label || obj.name;
                            }
                        }
                        if(Array.isArray(data) && data.length){
                            if(currentItem.checkboxList){
                                let checkboxList = currentItem.checkboxList;
                                valuetext = data.map(it => {
                                  let checkbox =  checkboxList.find(item => (item.id || item.value) == data) || {}
                                  return checkbox.label || checkbox.name;
                                })
                            }
                            if(valuetext){
                                let value =  valuetext.filter(it => it);
                                arr.push({
                                    label: currentItem.label,
                                    key: key,
                                    value: value 
                                })
                            }
                        }else if(typeof data === 'string' && data.trim()){
                            arr.push({
                                label: currentItem.label,
                                key: key,
                                value: valuetext 
                            })
                        }else if(Number(data) !== NaN && !Array.isArray(data)){
                            arr.push({
                                label: currentItem.label,
                                key: key,
                                value: valuetext 
                            })
                        }
                    }

                }
                requestParam = arr;
                // this.sendData('click', this, arr);
            },
          // 监听body下面的第一个div的'click';
          new Vue().$nextTick(() => {
            document.addEventListener('click', (e) => {
                  currentElement = this.getEleInfo(e);
                  let vm = this;
                  clickTime = new Date();
                  // 想不起来为啥要加节流了，也不知道为啥有个2000的时间，
                  // 现在把时间改为0，是因为，页面上点击某个按钮然后跳转之后，因为2000毫秒的时间，导致获取到的页面路由不对
                  let func = vm.throttle(vm.sendData, 0)
                  func('click', vm)
              })
              isReady = true;
              // ios下面，并且userInfo没有值情况下
              if(this.isIOS() && !userInfo.appVersion){
                window.WebViewJavascriptBridge && window.WebViewJavascriptBridge.callHandler('getCurrentTime', null, (data) => {
                  userInfo = JSON.parse(data)
                })
              }
          })
          this.getLocation();
          // this.getProvince();
      },
      // 节流
      throttle(func, delay) {            
        var timer = null; 
        return function(...args) {                
            var context = this;               
            if (!timer) {                    
                timer = setTimeout(function() {
                  func.apply(context, args);                        
                  timer = null;                    
                }, delay);                
            }            
        }      
      },      
      setupWebViewJavascriptBridge(callback) {
        var u = navigator.userAgent;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
        if (isAndroid) {
          if (window.WebViewJavascriptBridge) {
            callback(WebViewJavascriptBridge)
          } else {
                  // 添加dom事件
            document.addEventListener(
              'WebViewJavascriptBridgeReady',
              function () {
                callback(WebViewJavascriptBridge)
              },
              false
            );
          }
            
        }
        if (isiOS) {
          console.log('isiOS')
          if (window.WebViewJavascriptBridge) {
            return callback(WebViewJavascriptBridge);
          }
          if (window.WVJBCallbacks) {
            return window.WVJBCallbacks.push(callback);
          }
          window.WVJBCallbacks = [callback];
          var WVJBIframe = document.createElement('iframe');
          WVJBIframe.style.display = 'none';
          WVJBIframe.src = 'https://__bridge_loaded__';
          document.documentElement.appendChild(WVJBIframe);
          setTimeout(function () {
            document.documentElement.removeChild(WVJBIframe)
          }, 0)
        }
      },
      getUserInfo(){
        if(browser.versions.AndroidApp || browser.versions.android){
            let info = window.android && window.android.getUserInfo()
            if (info) {
                userInfo = JSON.parse(info)
            }
        }else {
          userInfo = {
            userId: localStorage.getItem('userId'),
            mobile: localStorage.getItem('mobile')
          }
        }
          
      },
      getTime(date){
          let currentDate = date ? new Date(date) : new Date();
          let year = currentDate.getFullYear();
          let mouth = currentDate.getMonth() + 1;
          let day = currentDate.getDate();
          let hours = currentDate.getHours();
          let minute = currentDate.getMinutes();
          let seconds = currentDate.getSeconds();
          if(mouth < 10){
              mouth = '0' + mouth;
          }
          if(day < 10){
              day = '0' + day;
          }
          if(hours < 10){
              hours = '0' + hours;
          }
          if(minute < 10){
              minute = '0' + minute;
          }
          if(seconds < 10){
              seconds = '0' + seconds;
          }
          return year + '-' + mouth + '-' + day + ' ' + hours + ':' + minute + ':' + seconds;
      },
      async sendData(eventName, vm, businessParams){
          // source: pc: 3, h5:  ios的话，4；安卓的话，5, 
          const key = CryptoJS.enc.Utf8.parse("49dee74b204e54ea")  // 十六位十六进制数作为密钥
          var tableId = ''
          if(eventName !== 'exposure'){
            if(!currentElement || (currentElement.$element_content == '' && eventName === 'click') ){
              return;
            }
            if(currentElement && currentElement.$element_content.length > 512){
              tableId = currentElement.$element_content.substring(0,512)
            }else {
              tableId = currentElement && currentElement.$element_content
            }
          }
          
          if(!userInfo.userId){
            if(vm.isIOS()){
              vm.setupWebViewJavascriptBridge();
            }else {
              vm.getUserInfo();
            }
          }
          let data = {
              appName: 1,
              event: eventName,
              source: vm.getSource(),
              pageId: eventName === 'view' ? lastRoute : eventName == 'exposure' ? businessParams.currentRoute : currentRoute,
              tableId: eventName === 'view' ? lastRoute : eventName == 'exposure' ? businessParams.tableId : tableId , // 浏览的话tableId为当前页面的名字，已和产品确认
              createTime: eventName === 'view' ? vm.getTime(entryTime) : eventName == 'exposure' ? vm.getTime(new Date()) : vm.getTime(clickTime),
              eventDuration: (entryTime && leaveTime ) ? vm.getEventDuration() : 0,
              userId: userInfo.userId,
              account: CryptoJS.AES.encrypt(userInfo.mobile, key, {mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7}).toString(),// 对手机号码加密
              systemVersion: vm.getSystemVersion(),
              appVersion: userInfo.appVersion, // 如货主的版本
              mobileType: userInfo.mobileType, // 暂时无法获取
              requestParam: eventName === 'click' ? requestParam && JSON.stringify(requestParam) : eventName == 'exposure' ? businessParams.requestParam : null,
              // 51104 DATA-198 新增字段
              sessionId: localStorage.getItem('tokenId'),// sessionid
              ip: localIp,// 本地ip
              resolution: window.screen.width + '*' + window.screen.height,// 分辨率
              longLat: longLat,// 经纬度,
              nation: 'CN'
          };
          let params = {
            transTime: vm.getTime(new Date()),
            data: [data],
            load: false
          }
          let appid = vm.getAppid();
          let nonce = vm.RondomPass(16);
          let timestamp = new Date().getTime();
          let signature = "appid=" + appid + "nonce=" + nonce + "timestamp=" + timestamp
          let srcs1 = CryptoJS.enc.Utf8.parse(signature) // 先将对象变为字符串，然后将这个字符串变为AES对象初始化，key也要经过AES对象初始化
          let encryStr1 = CryptoJS.AES.encrypt(srcs1, key, {mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7}).toString() // 需要改为字符串
          // axios.defaults.withCredentials = true;//Cookie跨域
          // axios.post('http://192.168.87.99:7879/bigdata/business/dataCollect', params, {
          let api = '';
          //  兼容 location.origin h5中老手机iphone6下和IE10
          if (!window.location.origin) {
            window.location.origin = window.location.protocol +  "//"  + window.location.hostname  + (window.location.port ? ':'  + window.location.port : '');
          }
          if(['production', 'prod'].includes(process.env.NODE_ENV)){
            if(location.origin.indexOf('172') !== -1 || location.origin.indexOf('pre') !== -1){
              api = 'http://172.20.21.185:7879';
            }else {
              api = 'https://bigdate-analysis.zczy56.com';
            }
            // if(location.origin.indexOf('https://hz.zczy56.com') !== -1){
            //   api = 'https://bigdate-analysis.zczy56.com';
            // }else {
            //   // api = 'http://172.20.21.185:7879';
            //   // 等上线之后改成这个
            //   api = 'http://172.20.21.185:7879';
            // }
          }else {
            api = 'http://172.20.21.185:7879';
          }
          requestParam = null;
          axios.post(api + '/bigdata/business/dataCollect', params, {
              headers: {
                Authorization: JSON.stringify({
                  appid: appid,
                  nonce: nonce,
                  timestamp: timestamp,
                  signature: encryStr1
                })
              },
              withCredentials: false,
              cors: true
          }).then(res => {
            requestParam = null;
          })
      },
      getSource(){
          if(/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)){
              return this.isIOS() ? 4 : 5;
          }else {
              return 3
          }
      },
      getAppid(){
          if(/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)){
              return this.isIOS() ? '001' : '002';
          }else {
              return '003'
          }
      },
      getSystemVersion(){
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)){
          return userInfo.systemVersion;
        }else {
          return this.getUA();
        }
      },
      getProvince(){
          let b = document.createElement('script');
          b.setAttribute('src', 'http://pv.sohu.com/cityjson?ie=utf-8')
          document.getElementsByTagName('head')[0].appendChild(b)
          setTimeout(() => {
              province = returnCitySN.cname;
              document.getElementsByTagName('head')[0].removeChild(b);
          }, 200)
      },
      RondomPass(number) {
        var arr = new Array();
        var arr1 = new Array('0', '1', '2', '3', '4', '5', '6', '7', '8', '9');
        var nonceStr = '';
        for (var i = 0; i < number; i++) {
            var n = Math.floor(Math.random() * 10);
            arr[i] = arr1[n];
            nonceStr += arr1[n];
        }
        return nonceStr;
      },
      getLocation(){
          var options = {
              enableHighAccuracy: true,
              maximumAge: 1000
          }
          if(navigator.geolocation){
              // 浏览器支持geolocation
              navigator.geolocation.getCurrentPosition(this.onSuccess,this.onError,options);
          }else{
              // 浏览器不支持geolocation
          }
      },
      // 成功时
      onSuccess(position){
          // 返回用户位置
          // 经度
          var longitude = position.coords.longitude;
          // 纬度
          var latitude = position.coords.latitude;
          longLat = longitude + ', ' + latitude;
      },
      // 失败时
      onError(error){
      },
  
      getEventDuration(){
        if(leaveTime < entryTime){
          return 0
        }else {
          return leaveTime.getTime() - entryTime.getTime();
        }
      },
      // 判断是不是ios
      isIOS() {
          return !!navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      // 获取ios版本
      getAppVersion() {
          let version = '';
          if( navigator.appVersion){
            if(this.isIOS()){
              version = navigator.appVersion.match(/OS (\d+)[._](\d+)[._]?(\d+)?/);
            }else {
              version = navigator.appVersion.match(/Android (\d+)[._](\d+)[._]?(\d+)?/);
            }
            return version && version.length > 3 ? version[1] + '.' + version[2] + '.' + version[3] : '';
          }else {
            return ''
          }
          
      },
      // 获取当前浏览版本
      getUA() {
          var Sys = {};
          var ua = navigator.userAgent.toLowerCase();
          var s;
          if ((s = ua.match(/opera.([\d.]+)/))) {
            Sys = s[0];
          } else if ((s = ua.match(/msie ([\d.]+)/))) {
            Sys = s[0];
          } else if ((s = ua.match(/edge.([\d.]+)/))) {
            Sys = s[0];
          } else if ((s = ua.match(/firefox\/([\d.]+)/))) {
            Sys = s[0];
          } else if ((s = ua.match(/chrome\/([\d.]+)/))) {
            Sys = s[0];
          } else if ((s = ua.match(/version\/([\d.]+).*safari/))) {
            Sys = s[0];
          } else if ((s = ua.match(/trident\/([\d.]+)/))) {
            Sys = 'ie/11';
          }
          return Sys.replace(/^["|'](.*)["|']$/g);
      },
      getElementContent(target, tagName) {
          var textContent = '';
          var element_content = '';
          if (target.textContent) {
            textContent = this.trim(target.textContent);
          } else if (target.innerText) {
            textContent = this.trim(target.innerText);
          }
          // 为了规避有的数据异常
          if(textContent.indexOf('%') !== -1){
            textContent = this.trim(target.innerText);
          }
          if (textContent) {
            textContent = textContent
              .replace(/[\r\n]/g, ' ')
              .replace(/[ ]+/g, ' ')
              .substring(0, 255);
          }
          element_content = textContent || '';
          if (tagName === 'input' || tagName === 'INPUT') {
            if (target.type === 'button' || target.type === 'submit') {
              element_content = target.value || '';
            } 
          }
          return element_content;
      },
      trim(str) {
          return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
      },
      getEleInfo(obj) {
          if (!obj.target) {
            return false;
          }
        
          var target = obj.target;
          var tagName = target.tagName.toLowerCase();
        
          var props = {};
  
          props.$childElementCount = target.childElementCount;
          props.$element_type = tagName;
          props.$element_name = target.getAttribute('name');
          props.$element_id = target.getAttribute('id');
          props.$element_class_name = typeof target.className === 'string' ? target.className : null;
          props.$element_target_url = target.getAttribute('href');
          props.$element_content = this.getElementContent(target, tagName);
          // props = this.strip_empty_properties(props);
          // props.$url = this.getURL();
          props.$url_path = location.pathname;
          props.$title = document.title;
          props.$viewport_width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || 0;
        
          return props;
      },
      strip_empty_properties(p) {
          var ret = {};
          each(p, function(v, k) {
            if (v != null) {
              ret[k] = v;
            }
          });
          return ret;
      },
      getURL(para) {
          if (isString(para)) {
            return _decodeURI(para);
          } else {
            return _decodeURI(location.href);
          }
      },
      _decodeURI(val) {
          var result = val;
          try {
            result = decodeURI(val);
          } catch (e) {
            result = val;
          }
          return result;
      },
      
  }
  